import React from "react";

import transportImg1 from "../../../../assets/Transporation_left.png";
import transportImg2 from "../../../../assets/Transporation_right.png";
import fullImg from "../../../../assets/BusFull.png";

import Classes from "./Index.module.css";

const Index = () => {
  return (
    <div className={Classes.section3}>
      <div className={Classes.section3_top}>
        <div className={Classes.section3_top_left}>
          <h1>Explore Places</h1>
          <h2>Transportation</h2>
        </div>
        <div className={Classes.section3_top_right}>
          <div>
            <h4>**UNAVAILABLE DUE TO COVID-19 RESTRICTIONS​</h4>
            <p>
              Our partnership with local trolley companies allows us to offer
              guests a convenient pickup and drop off right in front of our
              hotel!
            </p>
            <p>
              <a href="#">Ogunquit Trolley Company </a> offers pick up 8AM –
              11PM from 6/27 – Labor Day every 20-30 minutes. Tel: 207-646-1411{" "}
            </p>
          </div>
          <p style={{ width: "max-content", maxWidth: "90vw" }}>
            <span>RATES: </span> $2.00/adult per ride + $1.50/child under 10 per
            ride
          </p>
        </div>
      </div>
      <div className={Classes.section_button}>
        <button className="btn_primary alter" style={{ marginRight: "2rem" }}>
          CALL NOW
        </button>
        <button className="btn_primary">BOOK NOW</button>
      </div>
      <div className={Classes.section3_bottom}>
        <img
          className={Classes.section3_bottom_image1}
          src={transportImg1}
          alt=""
        />
        <img className={Classes.section3_bottom_image2} src={fullImg} alt="" />
        <img
          className={Classes.section3_bottom_image3}
          src={transportImg2}
          alt=""
        />
      </div>
    </div>
  );
};

export default Index;
